import { render, staticRenderFns } from "./our-projects-list.vue?vue&type=template&id=274de322&scoped=true&"
import script from "./our-projects-list.vue?vue&type=script&lang=js&"
export * from "./our-projects-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274de322",
  null
  
)

export default component.exports